import { render } from "./PublicationOverview.vue.js?vue&type=template&id=0aa0e6e8!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationOverview.vue?vue&type=template&id=0aa0e6e8"
import script from "./PublicationOverview.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationOverview.vue?vue&type=script&lang=js"
export * from "./PublicationOverview.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/PublicationOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0aa0e6e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0aa0e6e8', __exports__)) {
    api.reload('0aa0e6e8', __exports__)
  }
  
  module.hot.accept("./PublicationOverview.vue.js?vue&type=template&id=0aa0e6e8!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationOverview.vue?vue&type=template&id=0aa0e6e8", () => {
    api.rerender('0aa0e6e8', render)
  })

}


export default __exports__